<div class="m-maskedlfield"
     :class="[{ 'm--is-disabled': isDisabled,
                'm--is-waiting': isWaiting,
                'm--is-readonly': isReadonly,
                'm--has-error': hasMaskedfieldError,
                'm--is-valid': isMaskedfieldValid,
                'm--has-label': hasLabel,
                'm--has-validation-message': hasValidationMessage } ]"
     @click="onClick"
     :style="{ width: inputWidth, maxWidth: inputMaxWidth }">
    <m-input-style class="m-maskedfield__input-style"
                   :disabled="isDisabled"
                   :waiting="isWaiting"
                   :error="hasMaskedfieldError"
                   :valid="isMaskedfieldValid"
                   :label="label"
                   :label-for="id"
                   :focus="isFocus"
                   :label-up="labelUp"
                   :empty="isEmpty"
                   :readonly="isReadonly"
                   :required-marker="requiredMarker"
                   :tag-style="tagStyle">
        <template slot="prefix">
            <slot name="prefix"></slot>
        </template>
        <m-input-mask v-model="model"
                      :id="id"
                      :autocomplete="autocomplete"
                      :disabled="isDisabled || isWaiting"
                      :readonly="isReadonly"
                      :placeholder="placeholder"
                      :raw="raw"
                      :options="maskOptions"
                      @blur="onBlur"
                      @change="onChange"
                      @focus="onFocus"
                      @keyup="onKeyup"
                      @keydown="onKeydown"
                      @paste="onPaste"
                      ref="inputMask"></m-input-mask>
        <template slot="suffix">
            <slot name="suffix"></slot>
        </template>
    </m-input-style>
    <div class="m-maskedfield__validation">
        <m-validation-message class="m-maskedfield__validation-message"
                              :disabled="isDisabled"
                              :waiting="isWaiting"
                              :error="hasMaskedfieldError"
                              :error-message="errorMessage"
                              :valid="isMaskedfieldValid"
                              :valid-message="validMessage"
                              :helper-message="helperMessage"></m-validation-message>
    </div>
</div>
